import Handler from "../Handler";
class RITHandler extends Handler {
    execute() {
    //   let receivedData = JSON.parse(message);
      this.service.processRIT();
    }
  }
  
  export default RITHandler;